import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLines = ({ lines, className = "", delay = 0.15, as: Tag = "h1", testid }) => (
  <Tag className={className} data-testid={testid}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Reveal = ({ children, className = "", delay = 0, y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0.001, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ kicker, title, sub, className = "" }) => (
  <Reveal className={`max-w-2xl ${className}`}>
    {kicker && <p className="kicker mb-4">{kicker}</p>}
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-[#2A1240]">{title}</h2>
    {sub && <p className="mt-5 text-base md:text-lg text-slate-300 leading-relaxed">{sub}</p>}
  </Reveal>
);
